import React from 'react'
import styles from './styles.module.css'

const Input = ({
	icon,
	rightIcon,
	label,
	value,
	onClick,
	className = '',
	disabled = false,
	variant = 'default',
	...rest
}) => {
	const handleKeyDown = (e) => {
		if (disabled) return
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault()
			if (typeof onClick === 'function') onClick(e)
		}
	}

	const renderIcon = (node) => {
		if (!node) return null
		if (typeof node === 'string') {
			return <img src={node} alt="" aria-hidden="true" />
		}
		return node
	}

	return (
		<div
			role="button"
			tabIndex={disabled ? -1 : 0}
			className={[
				styles['v2-input'],
				disabled ? styles['v2-input--disabled'] : '',
				variant === 'column' ? styles['v2-input--column'] : '',
				className,
			]
				.filter(Boolean)
				.join(' ')}
			onClick={disabled ? undefined : onClick}
			onKeyDown={handleKeyDown}
			{...rest}
		>
			{icon && <span className={styles['v2-input__icon']}>{renderIcon(icon)}</span>}
			{(label != null || value != null) && (
				<span className={styles['v2-input__texts']}>
					{label != null && <span className={styles['v2-input__label']}>{label}</span>}
					{value != null && <span className={styles['v2-input__value']}>{value}</span>}
				</span>
			)}
			{rightIcon && (
				<span className={styles['v2-input__right-icon']}>
					{renderIcon(rightIcon)}
				</span>
			)}
		</div>
	)
}

export default Input



// WEBPACK FOOTER //
// ./src/components/V2/input/index.jsx